
/*
* from yii.validation.js captcha
* */
export const checkCaptcha = (value, hash, caseSensitive = false) => {
    let v = caseSensitive ? value : value.toLowerCase()
    let h = 0
    for (let i = v.length - 1; i >= 0; --i) {
        h += v.charCodeAt(i);
    }
    return h === hash
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/helpers/forms.js